import React, { useState } from "react";

import {
  TextField,
  Grid,
  Button,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Alert,
  Radio,
  FormLabel,
  CircularProgress,
} from "@mui/material";

import Categories from "../components/categories.component";
import axiosClient from "../axiosClient";

import { useStateContext } from "../context/ContextProvider";

export default function CategoriesScreen() {
  const [showCategoryForm, setShowCategoryForm] = useState(false);
  const [active, setActive] = useState("true");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  
  const [name,setName] = useState('');

  const { store } = useStateContext();

  if (loading) {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <CircularProgress />
        </Grid>
      </Grid>
    );
  }

  if (showCategoryForm) {
    return (
      <div>
        <Grid container direction="row" alignItems="center" spacing={2}>
          {errorMessage && (
            <Grid item xs={12} md={6} lg={6} sm={6}>
              <Alert severity="error" sx={{ marginBottom: 2 }}>
                {errorMessage}
              </Alert>
            </Grid>
          )}
        </Grid>
        <Grid container direction="row" alignItems="center" spacing={2}>
          <Grid item xs={12} md={2} lg={2} sm={2}>
            <TextField label="Category name" 
            autoFocus
            value={name}
            onChange={(e) => setName(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={2} lg={2} sm={2}>
            <FormControl component="fieldset">
              <FormLabel component="legend">Active</FormLabel>
              <RadioGroup row  value={active} onChange={(e) => setActive(e.target.value)}>
                <FormControlLabel
                  value="true"
                  control={<Radio />}
                  label="True"
                />
                <FormControlLabel
                  value="false"
                  control={<Radio />}
                  label="False"
                />
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={2} lg={2}>
            <Button
              variant="contained"
              sx={{ marginBottom: 2 }}
              color="success"
              size="small"
              onClick={() => {
                setLoading(true);
                const correctStoreName = JSON.parse(store).name.replace(/[^a-zA-Z]/g,"");
                const databaseStoreName = `DB301_${JSON.parse(store).id}_${correctStoreName}`;

                const payload = {
                  params: {
                    name: name,
                    display: active,
                    shopName: databaseStoreName,
                  },
                };

                axiosClient
                  .post("categories/create", payload)
                  .then(() => {
                    setLoading(false);
                    setShowCategoryForm(false);
                    setName('')
                    setErrorMessage('')
                  })
                  .catch((err) => {
                    const errorMessage = err.response.data.err.errors.map(
                      (e) => {
                        return (
                          <>
                            {e.message}
                            <br></br>
                          </>
                        );
                      }
                    );
                    setLoading(false);
                    setErrorMessage(errorMessage);
                  });
              }}
            >
              Add category
            </Button>
            <Button
              variant="contained"
              sx={{ marginBottom: 2, marginLeft: 2 }}
              color="error"
              size="small"
              onClick={()=> { setShowCategoryForm(false);
                setErrorMessage('')
              }}
            >
              Cancel
            </Button>
          </Grid>
        </Grid>
      </div>
    );
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Categories setShowCategoryForm={setShowCategoryForm} />
      </Grid>
    </Grid>
  );
}
